<template>
  <div class="offer-admin-discount hide-in-pdf" v-bind:class="{ 'disabled': !isEditable }" v-if="(this.$store.state.userRole === 'admin')">
    <span class="title" v-html="translate('discount')"/>
    <div class="edit-box">
      <input type="text" class="edit-input" v-model="discount" v-if="isEditable">
      <input type="text" class="edit-input" v-else v-bind:value="discount">
      <span class="percent">%</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "offer_admin_discount",
    data() {
      return {
        discount: 0,
      }
    },
    watch:{
      discount(val){
        let parsedValue = val;

        if(isFinite(val) && parseFloat(val).toString() != val.toString()){
          parsedValue = parseFloat(val);

          this.discount = parsedValue;
        }

        if(isNaN(parsedValue)) {
          parsedValue = 0;
          this.discount = parsedValue;
        }

        if(parsedValue > 100)
          this.discount = 100;
        else if(parsedValue < 0)
          this.discount = 0;

        this.$store.state.discount.offerDiscountGivenByTheAdministrator = parsedValue;
      }
    },
    methods: {
      translate(code) {
        let arg = {
          type: 'translate',
          code: code,
          out: ""
        }

        this.$store.commit(arg);

        return arg.out;

      },
    },

    computed: {
      isEditable() {
        if (this.$store.getters.getUserRole !== 'admin') return false;
        return this.$store.getters.isOfferEditable;
      },
    },
    beforeMount() {
      this.discount = this.$store.state.discount.offerDiscountGivenByTheAdministrator;
    }
  }
</script>